'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { switchMap } from 'rxjs/operators/switchMap';
import { FETCHED_STATIC_LISTS } from '../actions/ActionTypes';
import { receiveStaticLists, requestedStaticListsFailed, requestStaticLists } from '../actions/ListsActions';
export default ((action$, _, {
  ListsClient
}) => action$.ofType(FETCHED_STATIC_LISTS).pipe(switchMap(({
  payload: {
    offset,
    search
  }
}) => ListsClient.fetchStaticLists(offset, search).pipe(map(receiveStaticLists), catchError(error => of(requestedStaticListsFailed(error))), startWith(requestStaticLists())))));